import S from "@babel/runtime/helpers/esm/classCallCheck";
import y from "@babel/runtime/helpers/esm/createClass";
import T from "@babel/runtime/helpers/esm/inherits";
import B from "@babel/runtime/helpers/esm/createSuper";
import i from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as A } from "@semcore/utils/lib/core/index";
import C, { sstyled as P, assignProps as x, Component as z } from "@semcore/core";
import n from "react";
import E from "@semcore/utils/lib/addonTextChildren";
import k from "@semcore/icon/ChevronDown/m";
import a from "./BaseTrigger.mjs";
import b from "@semcore/spin";
import w from "@semcore/utils/lib/enhances/animatedSizeEnhance";
import { cssVariableEnhance as R } from "@semcore/utils/lib/useCssVariable";
var D = (
  /*__reshadow_css_start__*/
  (A.insert(
    /*__inner_css_start__*/
    ".___SButtonAddon_omz2v_gg_{width:12px;height:12px}.___SButtonTriggerSpin_omz2v_gg_{fill:var(--intergalactic-icon-primary-neutral, #6c6e79)}",
    "omz2v_gg_"
  ), {
    __SButtonAddon: "___SButtonAddon_omz2v_gg_",
    __SButtonTriggerSpin: "___SButtonTriggerSpin_omz2v_gg_"
  })
), e = /* @__PURE__ */ function(g) {
  T(r, g);
  var d = B(r);
  function r() {
    return S(this, r), d.apply(this, arguments);
  }
  return y(r, [{
    key: "getTextProps",
    value: function() {
      return {
        tag: "span"
      };
    }
  }, {
    key: "getAddonProps",
    value: function() {
      return {
        tag: "span"
      };
    }
  }, {
    key: "render",
    value: function() {
      var l = this.asProps, o, _ = s.Addon, u = b, t = this.asProps, c = t.Children, f = t.styles, m = t.loading, h = t.chevron, v = t.empty;
      return o = P(f), /* @__PURE__ */ n.createElement(a, x({}, l), E(c, s.Text, s.Addon, v), (h || m) && /* @__PURE__ */ n.createElement(_, o.cn("SButtonAddon", {}), m ? /* @__PURE__ */ n.createElement(u, o.cn("SButtonTriggerSpin", {
        size: "xs",
        theme: !1
      })) : /* @__PURE__ */ n.createElement(k, o.cn("ChevronDown", {}))));
    }
  }]), r;
}(z);
i(e, "displayName", "ButtonTrigger");
i(e, "style", D);
i(e, "enhance", [R({
  variable: "--intergalactic-duration-control",
  fallback: "200",
  map: Number.parseInt,
  prop: "duration"
}), w({
  animateProps: ["width"],
  onChangeOf: ["value"]
})]);
i(e, "defaultProps", {
  chevron: !0
});
var s = C(e, {
  Text: a.Text,
  Addon: a.Addon
}, {
  parent: a
});
export {
  s as default
};
